// expected output: "123.456,79 => MOZAMBIQUE FORMAT"
export const formatCurrency = (value) => {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  })
    .format(isNaN(value) ? 0 : value)
    .replaceAll("€", "");
};
